var styles = {"dialog":"bc-exercise-dialog__dialog","pauseButton":"bc-exercise-dialog__pauseButton","service-not-available":"bc-exercise-dialog__service-not-available","serviceNotAvailable":"bc-exercise-dialog__service-not-available"};

export { styles as default };
